import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';

import { CurrencyService } from '../shared/services/currency.service';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class CurrencyResolver {
  constructor(private currency: CurrencyService) {}

  resolve(): Observable<any> {
    if (this.currency.loaded) {
      return null;
    } else {
      return this.currency.getCurrencies().pipe(map((currencies) => currencies));
    }
  }
}
